import type { AppRouteRecord } from '../types';
import { ROUTE_NAMES, ROUTE_PATHS } from '../constants';

export const payrollRoutes: AppRouteRecord[] = [
  {
    path: ROUTE_PATHS.PAYROLL,
    name: ROUTE_NAMES.PAYROLL,
    component: () => import('@/pages/PayrollPage.vue'),
  },
];
